import { CustomAccordion } from '@/components/common';
import {
	PageContainer,
	ReadyToGetBanner,
	SimpleBanner,
} from '@/components/landing';
import { FAQS } from '@/const/landing';

export const FrequentlyQuestions: React.FC = () => {
	const filteredFaqs = FAQS.map((question, index) => {
		if (index === 4) {
			question = {
				...question,
				content: <>{question.content} </>,
			};
		}
		return question;
	});

	return (
		<>
			<SimpleBanner
				text="Frequently Asked Questions"
				description="Everything You Need to Know About Simplifying Your Legal Journey"
			/>
			<PageContainer className="!max-w-[825px]">
				<CustomAccordion information={filteredFaqs} />
			</PageContainer>
			<ReadyToGetBanner classNameContainer="mx-4" />
		</>
	);
};
